var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"poster",staticClass:"poster"},[_c('img',{staticClass:"poster__img",attrs:{"src":_vm.img}}),_vm._v(" "),_c('img',{staticClass:"poster__qrcode",attrs:{"src":_vm.qrcode}})])
}
var staticRenderFns = []

export { render, staticRenderFns }